import FetchService from "./Shared/FetchService";
import PersonDegreeProgramDomainService from "../Domain/PersonDegreeProgram/PersonDegreeProgram.service";
const ADVISOR_URL = "/aviso/advisor";
const DEGREE_PROGRAM_URL = "/aviso/degreeProgram";
export default class PersonDegreeProgramService {
    static getForStudent(affiliationId) {
        return FetchService.get(ADVISOR_URL + "/getPersonDegreePrograms", {
            affiliationId,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        }).then((resp) => resp.map(PersonDegreeProgramDomainService.fromJSON));
    }
    static getStudentDegreeProgramInfo(affiliationId) {
        return FetchService.getSingleResponse(DEGREE_PROGRAM_URL + "/getStudentDegreeProgramInfo", {
            affiliationId,
        });
    }
}
